<template>
  <div>
    <transition name="zoom" >
      <w-button v-show="mustShow"  data-test="recorderStartPauseButton"
                color="outlined"
                icon="plus" v-if="!isOpenAvatarEditingContent && !isAvatarOptionPanelOpened" :enabled="isButtonEnabled"
                :tooltip="tooltip" @click="openAvatarContent">
        {{$t('createWeetComponent.record.button.writeScript')}}
      </w-button>
    </transition>
    <transition name="zoom">
      <div v-show="!isProceedSlideInProgress && slides.length>0 && isOpenAvatarEditingContent " class="slidesControlBar" v-if="currentSlide" >
          <w-button class="buttonPrev" icon="chevron-left"  color="outlined"
                    size="small" @click="prevSlide"
                    :enabled="currentSlide && currentSlide.order>1 && !isImageGenerationInProgress && !isVideoChunkGenerating"></w-button>

        {{currentSlide.order}} / {{slides.length}}

        <w-button class="buttonNext" icon="chevron-right" color="outlined"
                  size="small"  @click="nextSlide"
                  :enabled="currentSlide && currentSlide.order<slides.length && !isImageGenerationInProgress && !isVideoChunkGenerating"></w-button>
      </div>

    </transition>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import WButton from "@/components/wrapper/w-button.vue";
import { OPEN_AVATAR_EDITING_CONTENT, SELECT_AI_SCRIPT_SLIDE_LAYOUT } from "@/store/AIAvatar/AIAVatarAction";
import { ScriptSlideLayout, Slide } from "@/store/slides2Video/slides2VideoModels";
import { SELECT_SLIDE } from "@/store/slides2Video/slides2VideoAction";
import { clone } from "@/utils/cloneUtil";
import { updateCurrentSlide } from "@/utils/slides/slideUtil";

@Component({
  components: {WButton},
})
export default class GenerateAvatarButton extends Vue {
  private mustShow: boolean = false;

  get isProceedSlideInProgress() {
    return store.getters.isProceedSlideInProgress;
  }

  get isOpenAvatarEditingContent(){
    return store.getters.isOpenAvatarEditionContent;
  }

  get isAvatarOptionPanelOpened(){
    return store.getters.isPanelOptionOpen
  }

  get isImageGenerationInProgress() {
    return store.getters.isImageGenerationInProgress
  }

  get isVideoChunkGenerating(){
    return store.getters.isVideoChunkGenerating;
  }


  get slides(){
    return store.getters.slides;
  }

  get currentSlide(): Slide | null {
    if (store.getters.getCurrentSlideIndex > -1) {
      return this.slides[store.getters.getCurrentSlideIndex]
    }
    return null;
  }
  get timeRemaining(){
    return store.getters.getAvatarAIremaining;
  }
  get isAIAvatarAuthorized(){
    return store.getters.isAvatarAI;
  }

  get isButtonEnabled():boolean{

    if(!this.isAIAvatarAuthorized){
      return false;
    }
    if(this.timeRemaining<=0){
      return false;
    }

    return true;
  }

  get tooltip(){
    if(!this.isAIAvatarAuthorized){
      return this.$t('createWeetComponent.aiAvatar.disabled')
    }
    if(this.timeRemaining<=0){
      return this.$t('createWeetComponent.aiAvatar.timeRemaining')
    }
    return "";
  }
  private mounted() {
    this.mustShow = true;
  }

  private prevSlide(){
    if(this.currentSlide){
      const index=this.currentSlide.order-2;
      store.dispatch(SELECT_SLIDE,index);
    }else {
      store.dispatch(SELECT_SLIDE, 0);
    }
  }

  private nextSlide(){
    if(this.currentSlide){
      const index=this.currentSlide.order;
      store.dispatch(SELECT_SLIDE,index);
    }else {
      store.dispatch(SELECT_SLIDE, 0);
    }
  }
  private openAvatarContent(){
    // update slides
    if (this.currentSlide) {
      const newSlide = clone(this.currentSlide) as Slide;
      newSlide.layout = ScriptSlideLayout.SLIDE;
      updateCurrentSlide(newSlide);
    }
    store.dispatch(SELECT_AI_SCRIPT_SLIDE_LAYOUT, ScriptSlideLayout.SLIDE);
    store.dispatch(OPEN_AVATAR_EDITING_CONTENT,true)
  }
}
</script>
<style scoped lang="scss">
.slidesControlBar{
  display: flex;
  justify-items: center;
  align-items: center;

  .buttonPrev{
    margin-right: 32px;
  }
  .buttonNext{
    margin-left: 32px;
  }
}
</style>
